var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":"dark","content":'用户：' + _vm.userInfo.name,"placement":"bottom"}},[_c('el-image',{style:({
      width: _vm.error ? '42px' : '40px',
      height: _vm.error ? '42px' : '40px',
      'margin-right': '10px',
      'border-radius': '100px',
      border: _vm.error ? '' : '1px solid ' + _vm.$jsTool.getColor('primary'),
    }),attrs:{"fit":"cover","src":_vm.userInfo.avatar
        ? _vm.userInfo.avatar.prefix + _vm.userInfo.avatar.name
        : 'null'},on:{"error":function($event){_vm.error = true}}},[_c('div',{staticClass:"fm-center",style:({
        height: '100%',
        'background-color': _vm.$jsTool.getColor('primary'),
        color: '#ffffff',
      }),attrs:{"slot":"error"},slot:"error"},[_vm._v("\n      "+_vm._s(_vm.subName)+"\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-720f00c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserAvatar.vue
// module id = null
// module chunks = 